import { render, staticRenderFns } from "./UnitAreaEnergyDialog.vue?vue&type=template&id=70c9c1d8&scoped=true"
import script from "./UnitAreaEnergyDialog.vue?vue&type=script&lang=js"
export * from "./UnitAreaEnergyDialog.vue?vue&type=script&lang=js"
import style0 from "./UnitAreaEnergyDialog.vue?vue&type=style&index=0&id=70c9c1d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9c1d8",
  null
  
)

export default component.exports